/**
 * Removes spaces from the string.
 * @param  {string} str The string to modify.
 * @returns {string}     The string without spaces.
 */
function trimSpacesStringUtil (str) {
  return str.replace(/\s+/g, '')
}

/**
 * Removes whitespace from both sides of a string.
 * Also removes extra white spaces in between words.
 * @example
 *
 * ```jsx
 *
 * let test = '   this    is a  test   '
 * trimExtraSpacesStringUtil(test) => 'this is a test'
 *
 * ```
 *
 * @param  {string} str
 * @returns {string}
 */
function trimExtraSpacesStringUtil (str) {
  return str.trim().replace(/\s+/g, ' ')
}

export {
  trimSpacesStringUtil,
  trimExtraSpacesStringUtil
}
